"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var navbarContext_1 = require("./navbarContext");
var Container = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  position: absolute;\n  top: calc(100% + 12px);\n  min-width: 256px;\n  right: 0;\n  background: #fff;\n  padding: 32px;\n  flex-direction: column;\n  opacity: 0;\n  transition: opacity 0.3s;\n  min-width: 440px;\n  border-radius: 14px;\n  box-shadow: 0 32px 80px -30px rgba(0, 0, 0, 0.17);\n\n  &::before {\n    content: \" \";\n    width: 12px;\n    height: 12px;\n    border-radius: 2px;\n    position: absolute;\n    top: -4px;\n    right: 24px;\n    background: #fff;\n    transform: rotate(45deg);\n    box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.5);\n  }\n"], ["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  position: absolute;\n  top: calc(100% + 12px);\n  min-width: 256px;\n  right: 0;\n  background: #fff;\n  padding: 32px;\n  flex-direction: column;\n  opacity: 0;\n  transition: opacity 0.3s;\n  min-width: 440px;\n  border-radius: 14px;\n  box-shadow: 0 32px 80px -30px rgba(0, 0, 0, 0.17);\n\n  &::before {\n    content: \" \";\n    width: 12px;\n    height: 12px;\n    border-radius: 2px;\n    position: absolute;\n    top: -4px;\n    right: 24px;\n    background: #fff;\n    transform: rotate(45deg);\n    box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.5);\n  }\n"])));
exports.DropDownItem = styled_1.default.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n"], ["\n  display: block;\n"])));
exports.DropDownCtx = react_1.createContext({
    open: false
});
exports.DropDown = function (_a) {
    var children = _a.children, id = _a.id;
    var _b = react_1.useContext(navbarContext_1.NavContext), isOpen = _b.isOpen, toggleMenu = _b.toggleMenu;
    var open = isOpen(id);
    react_1.useEffect(function () {
        var onBodyClick = function () {
            if (open) {
                toggleMenu(id);
            }
        };
        window.addEventListener("click", onBodyClick);
        return function () { return window.removeEventListener("click", onBodyClick); };
    }, [open]);
    return (react_1.default.createElement(exports.DropDownCtx.Provider, { value: { open: open } },
        react_1.default.createElement(Container, { style: {
                display: open ? "flex" : "none",
                opacity: open ? 1 : 0
            }, onClick: function (e) {
                e.stopPropagation();
                toggleMenu(id);
            } }, children)));
};
var templateObject_1, templateObject_2;
